// Environment Configuration
// Change this value to switch between 'dev' and 'prod'
export const ENV = 'dev'; // Options: 'dev' or 'prod'

// Environment-specific configurations
const CONFIG = {
  dev: {
    // Base URLs
    API_URL_BASE: "https://internal-api.dev.hav-g.in",
    CRM_BASE_URL: "https://erp.dev.hav-g.in",
    FORM_URL: "https://form.dev.hav-g.in/",
    FORMV2S_URL: "https://formv2s.dev.hav-g.in/",
    CMS_URL: "https://erp.cms.traya.health",
    PREVIEW_URL: "https://form-result.dev.hav-g.in",

    // API URLs
    SECURITY_TOKEN_FORM: "e2623576-930b-48b6-81e2-a3cb5e37f47d",
    PUBLIC_SERVICE_URL: "https://public-zxhj2.dev.hav-g.in/",
    CDN_BASE_URL: "https://d3twoz8hvcdm9h.cloudfront.net/",
    TICKETING_SERVICE_URL: "http://v2-ticketing-service-dev-dev:3000",

    // Ticket IDs
    MEDICAL_ESCALATION_TICKET_ID: "68e62f2773cd1904533fa159",
    CUSTOMER_COMPLAINT_TICKET_ID: "6503644b83426f444392c642",

    // Team Member IDs - Operations Team
    OPS_TEAM: {
      "jaiswalneelu@traya.health": {
        value: "126781d4-e984-461e-92c2-ad5fe06845e6",
        label: "Neelu",
      },
      "ganeshkamble@traya.health": {
        value: "00b41390-63d5-466e-b9a4-a270b9f5f16d",
        label: "Ganesh Kamble",
      },
      "sindhu@tatva.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Sindhu",
      },
      "patilgaurang@traya.health": {
        value: "00af1fe6-1242-42c0-9192-998f09c5bee0",
        label: "Gaurang",
      },
      "deyashish@traya.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Ashish",
      },
      "yadavpratibha@traya.health": {
        value: "01606e96-fc51-480c-8542-1040528a82dc",
        label: "Pratibha",
      },
      "mitraparth@traya.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Parth",
      },
      "choudharyphilona@traya.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Philona Choudhary",
      },
      "kripapurohit@tatvarthahealth.com": {
        value: "8ded31fb-efc7-40b3-9c8c-ef6ba6997010",
        label: "Kripa Purohit",
      },
      "sangeetagupta@tatvarthahealth.com": {
        value: "f5d85e32-64af-4c49-a2c9-059464398a02",
        label: "Sangeeta Gupta",
      },
      "khanahad@tatvarthahealth.com": {
        value: "eca2ddd7-8ddd-4c87-8c61-a8f89bf85b03",
        label: "Khan Ahmad",
      },
      "shahrehan@tatvarthahealth.com": {
        value: "9dff74aa-34d3-4877-a268-3361ffcb1b0e",
        label: "Rehan Shah",
      },
      "faizansari@tatvarthahealth.com": {
        value: "429530e4-3e21-4860-99f7-3faec709cedc",
        label: "Faiz Ansari",
      },
      "pranalighadigaonkar@traya.health": {
        value: "00f941d7-8c24-4e8d-a60c-8f0432378ec6",
        label: "Pranali Ghadigaonkar",
      },
      "vinayshinde@traya.health": {
        value: "31e0e25c-316c-4dc1-8dd7-27889fe7ce3b",
        label: "Vinay Shinde",
      },
      "shyamlikamane@traya.health": {
        value: "f4ffbe49-bda9-4f17-b2d3-c69451cf9b68",
        label: "Shyamli Kamane",
      },
      "aakashbhatia@traya.health": {
        value: "0264d48e-915b-4908-a378-507adea016f5",
        label: "Aakash Bhatia",
      },
      "finance.tickets@traya.health": {
        value: "0264d48e-915b-4908-a378-507adea016f5",
        label: "Finance Tickets",
      },
      "priyadarshini@traya.health": {
        value: "fa980523-4ac9-4483-9c21-d6fd4f8c606d",
        label: "Priyadarshni Raju",
      },
      "darshanakadam@traya.health": {
        value: "0264d48e-915b-4908-a378-507adea016f5",
        label: "Darshana Kadam",
      },
      "ibrahimkhan@traya.health": {
        value: "0264d48e-915b-4908-a378-507adea016f5",
        label: "Ibrahim Khan",
      },
    },

    // Team Member IDs - Tech Team
    TECH_TEAM: {
      "agarwalsandip@traya.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Sandip Agarwal",
      },
    },

    // Team Member IDs - Escalation Team
    ESCALATION_TEAM: {
      "priyankakanojia@traya.health": {
        value: "00f941d7-8c24-4e8d-a60c-8f0432378ec6",
        label: "Priyanka kanojia",
      },
      "khanmahenaaz@traya.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Khan Mahenaaz",
      },
      "siddhi@tatva.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Siddhi",
      },
      "kalyani@tatva.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Kalyani",
      },
      "harish@traya.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Harish",
      },
      "shefali@tatva.health": {
        value: "4d2b3116-81f8-4901-8a63-144e154b051f",
        label: "Shefali",
      },
    },
  },

  prod: {
    // Base URLs
    API_URL_BASE: "https://internal-api-ank7tb.hav-g.in",
    CRM_BASE_URL: "https://erp.traya.health",
    FORM_URL: "https://form.dev.hav-g.in/",
    FORMV2S_URL: "https://form.traya.health/",
    CMS_URL: "https://erp.cms.traya.health",
    PREVIEW_URL: "https://result.traya.health",

    // API URLs
    SECURITY_TOKEN_FORM: "d7ef603e-71ea-44a1-93f2-2bacd08c4a90",
    PUBLIC_SERVICE_URL: "https://public-jgfas325.hav-g.in/",
    CDN_BASE_URL: "https://dvv8w2q8s3qot.cloudfront.net/",
    TICKETING_SERVICE_URL: "TODO_PROD_TICKETING_SERVICE_URL",

    // Ticket IDs
    MEDICAL_ESCALATION_TICKET_ID: "6503629683426f444392c55c",
    CUSTOMER_COMPLAINT_TICKET_ID: "6503644b83426f444392c642",

    // Team Member IDs - Operations Team
    OPS_TEAM: {
      "jaiswalneelu@traya.health": {
        value: "91ce29b3-5e45-4411-b0e0-7c0ef6954599",
        label: "Neelu",
      },
      "ganeshkamble@traya.health": {
        value: "18ef9561-3d85-4f6e-a166-74bba0df828e",
        label: "Ganesh Kamble",
      },
      "sindhu@tatva.health": {
        value: "eb4012d2-408b-4e22-b979-4c5af9dc2aab",
        label: "Sindhu",
      },
      "patilgaurang@traya.health": {
        value: "1105394b-d5b8-459f-b5bd-721a77cc3a1c",
        label: "Gaurang",
      },
      "deyashish@traya.health": {
        value: "1c911188-5dcd-404e-9f28-b38213491796",
        label: "Ashish",
      },
      "yadavpratibha@traya.health": {
        value: "873ed717-13d0-45b6-80dc-d572dffb0be2",
        label: "Pratibha",
      },
      "mitraparth@traya.health": {
        value: "d8c044ee-e3fc-4519-a12f-94ec87a56124",
        label: "Parth",
      },
      "choudharyphilona@traya.health": {
        value: "3b311a50-7606-4524-b711-a4888c3143b2",
        label: "Philona Choudhary",
      },
      "kripapurohit@tatvarthahealth.com": {
        value: "prod-placeholder",
        label: "Kripa Purohit",
      },
      "sangeetagupta@tatvarthahealth.com": {
        value: "prod-placeholder",
        label: "Sangeeta Gupta",
      },
      "khanahad@tatvarthahealth.com": {
        value: "prod-placeholder",
        label: "Khan Ahmad",
      },
      "shahrehan@tatvarthahealth.com": {
        value: "prod-placeholder",
        label: "Rehan Shah",
      },
      "faizansari@tatvarthahealth.com": {
        value: "prod-placeholder",
        label: "Faiz Ansari",
      },
      "pranalighadigaonkar@traya.health": {
        value: "12a4310b-18d1-4e40-927c-ba9260c6c7c9",
        label: "Pranali Ghadigaonkar",
      },
      "vinayshinde@traya.health": {
        value: "20e847fb-ad35-422e-8f1b-094d8bc7ac67",
        label: "Vinay Shinde",
      },
      "shyamlikamane@traya.health": {
        value: "b843e70f-6660-45bf-9938-edb97a4b0e0b",
        label: "Shyamli Kamane",
      },
      "aakashbhatia@traya.health": {
        value: "9648a23b-64eb-4ce9-b890-98b3fff49d93",
        label: "Aakash Bhatia",
      },
      "finance.tickets@traya.health": {
        value: "7e200d93-8429-44cf-891d-25e7be171045",
        label: "Finance Tickets",
      },
      "priyadarshini@traya.health": {
        value: "0836d1de-d378-49de-957b-d8c25b3cddda",
        label: "Priyadarshni Raju",
      },
      "darshanakadam@traya.health": {
        value: "f4470433-018b-4b75-a9f7-cedea85fe563",
        label: "Darshana Kadam",
      },
      "ibrahimkhan@traya.health": {
        value: "a96509ac-5aa0-4c68-9227-3df351fdd66a",
        label: "Ibrahim Khan",
      },
    },

    // Team Member IDs - Tech Team
    TECH_TEAM: {
      "agarwalsandip@traya.health": {
        value: "4f9f70c7-f4e1-466e-a387-01d359fd9b93",
        label: "Sandip Agarwal",
      },
    },

    // Team Member IDs - Escalation Team
    ESCALATION_TEAM: {
      "priyankakanojia@traya.health": {
        value: "3d095db2-c84a-4d27-9e2c-c3b37d7793ab",
        label: "Priyanka kanojia",
      },
      "khanmahenaaz@traya.health": {
        value: "fbbdd445-3df2-48ee-8726-4e96856ce78c",
        label: "Khan Mahenaaz",
      },
      "siddhi@tatva.health": {
        value: "8906e2cb-11c6-4f8b-8def-54d7c40deeab",
        label: "Siddhi",
      },
      "kalyani@tatva.health": {
        value: "1c290664-1ea9-43bc-81f1-554d26eee917",
        label: "Kalyani",
      },
      "harish@traya.health": {
        value: "c5fc686a-8f31-4419-8151-fd8e5c1ee7ee",
        label: "Harish",
      },
      "shefali@tatva.health": {
        value: "51e339f9-4d49-4af1-9c0d-f5662e43c1d1",
        label: "Shefali",
      },
    },
  },
};

// Export environment-based values
export const baseURL = {
  API_URL_BASE: CONFIG[ENV].API_URL_BASE,
  CRM_BASE_URL: CONFIG[ENV].CRM_BASE_URL,
  PREVIEW_URL: CONFIG[ENV].PREVIEW_URL,
  FORM_URL: CONFIG[ENV].FORM_URL,
  FORMV2S_URL: CONFIG[ENV].FORMV2S_URL,
  CMS_URL: CONFIG[ENV].CMS_URL,
};

export const SECURITY_TOKEN_FORM = CONFIG[ENV].SECURITY_TOKEN_FORM;
export const PUBLIC_SERVICE_URL = CONFIG[ENV].PUBLIC_SERVICE_URL;
export const CDN_BASE_URL = CONFIG[ENV].CDN_BASE_URL;
export const TICKETING_SERVICE_URL = CONFIG[ENV].TICKETING_SERVICE_URL;
export const MEDICAL_ESCALATION_TICKET_ID = CONFIG[ENV].MEDICAL_ESCALATION_TICKET_ID;
export const CUSTOMER_COMPLAINT_TICKET_ID = CONFIG[ENV].CUSTOMER_COMPLAINT_TICKET_ID;
export const opsTeamMember = CONFIG[ENV].OPS_TEAM;
export const techTeamMember = CONFIG[ENV].TECH_TEAM;
export const escalationTeamMember = CONFIG[ENV].ESCALATION_TEAM;
